// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attributions-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem 1.5rem;
    line-height: 1.6;
}

.attributions-title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    text-align: center;
}

.attributions-section {
    margin-bottom: 2rem;
}

    .attributions-section h2 {
        font-size: 1.4rem;
        margin-bottom: 0.75rem;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.25rem;
    }

.attributions-list {
    list-style: disc;
    padding-left: 1.5rem;
    margin-top: 0.5rem;
}

    .attributions-list li {
        margin-bottom: 0.4rem;
    }

.attributions-note {
    margin-top: 1rem;
    font-size: 0.9rem;    
}

a {
    color: #0066cc;
    text-decoration: none;
}

    a:hover {
        text-decoration: underline;
    }
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/Attributions.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;IAEI;QACI,iBAAiB;QACjB,sBAAsB;QACtB,6BAA6B;QAC7B,uBAAuB;IAC3B;;AAEJ;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;IAEI;QACI,qBAAqB;IACzB;;AAEJ;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;IAEI;QACI,0BAA0B;IAC9B","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.attributions-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 2rem 1.5rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.attributions-title {\r\n    font-size: 2rem;\r\n    margin-bottom: 1.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.attributions-section {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n    .attributions-section h2 {\r\n        font-size: 1.4rem;\r\n        margin-bottom: 0.75rem;\r\n        border-bottom: 1px solid #ddd;\r\n        padding-bottom: 0.25rem;\r\n    }\r\n\r\n.attributions-list {\r\n    list-style: disc;\r\n    padding-left: 1.5rem;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n    .attributions-list li {\r\n        margin-bottom: 0.4rem;\r\n    }\r\n\r\n.attributions-note {\r\n    margin-top: 1rem;\r\n    font-size: 0.9rem;    \r\n}\r\n\r\na {\r\n    color: #0066cc;\r\n    text-decoration: none;\r\n}\r\n\r\n    a:hover {\r\n        text-decoration: underline;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
